/* HC - Monogram feature adjustments - 26 Aug '20 */
jQuery(document).ready(function($){
  $('#hc-monogram__prompt').on('change', function(){
    var checked = $(this).prop('checked');

    if (checked) {
      $('#hc-monogram__wrapper').slideDown();
      
    } else {
      
      /* HC - Monogram feature adjustments - 07 Sep '20 */
      $('#monogram').val('');
      $('#hc-monogram__wrapper').slideUp();
      
    }
  });
});

$(document).on('click', '.hc-remove', function(e) {
    
  var hc_monogram = $(this).siblings('.product-customizer-line-item-prop').attr('data-prop-name');
  var hc_id = $(this).attr('data-id');
  var hc_qty_main;
  var hc_main_id = $(this).attr('data-main-id');
  
  var update = {};
  
  if(hc_monogram == 'Monogram'){
    
    e.preventDefault();
    
    hc_qty_main = 0;
    
    $.ajax({
      type: 'get',
      url: '/cart.js',
      dataType: 'json',
      async: false,
      success: function(cart) {

        $(cart.items).each(function(index, item) {
          if(cart.items[index].properties.Monogram.indexOf('Monogram') != ''){
            hc_qty_main = hc_qty_main + 1;
          } 
        });
 
      }
    });
    
    update[hc_id] = hc_qty_main - 1;
    update[hc_main_id] = 0;

    $.ajax({
      method: 'POST',
      datatype: 'json',
      data: { updates: update },
      url: '/cart/update.js',
      async: false,
      success: function(){
        location.href = '/cart';
      },
      error: function(message){
        if (message['status'] == 200) {
         location.href = '/cart';
        }
      }
    });
  }
});

